import SideMenu from "./SideMenu";
import { socket } from "../../socket";
import React, { useEffect, useState } from "react";

function Layout(props) {
  const [notifications, setNotifications] = useState([]);
  const [latestNotification, setLatestNotification] = useState(null);
  const [sideBarToggle, setSideBarToggle] = useState(false);

  useEffect(() => {
    if (props.selectedKitchen?.status === "Pending") {
      setLatestNotification({
        title: "Great work!",
        message: (
          <>
            Your kitchen is pending approval! We will be in touch shortly once
            we've reviewed your application. In the meantime, add your dishes
            here!{" "}
            <br />
            <br />
            <a href="/dishes" className="btn btn-sm btn-light rounded ms-2">
              Add my dishes
            </a>
          </>
        ),
        color: "warning",
      });
    }

    if (props.selectedKitchen?.status === "Approved") {
      setLatestNotification({
        title: props.selectedKitchen.is_live
          ? "Your kitchen is now live!"
          : "Your kitchen is ready to go live!",
        message: props.selectedKitchen.is_live
          ? "Your kitchen is now available on the Fale Marketplace, customers are able to order your food. Congrats!"
          : "Your kitchen has been approved by Tino and is now able to go live. Congrats!",
        color: props.selectedKitchen.is_live ? "success" : "info",
      });
    }
  }, [props.selectedKitchen]);

  socket.on("NEW_ORDER_FOR_OWNER", (data) => {
    // let audio = new Audio("/assets/sounds/notification.mp3");
    // audio.play();
    setNotifications([...notifications, data]);
    setLatestNotification(data);
    setTimeout(() => {
      setLatestNotification(null);
    }, 10000);
  });

  socket.on("ORDER_PAID", (data) => {
    setNotifications([...notifications, data]);
    setLatestNotification(data);
    setTimeout(() => {
      setLatestNotification(null);
    }, 10000);
  });

  return (
    <div className={`page-wrapper${sideBarToggle ? " toggled" : ""}`}>
      <SideMenu {...props} />
      <div className="main-container">
        <div className="page-header">
          <div className="row gutters">
            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-9">
              <div className="search-container">
                <div
                  tabIndex={0}
                  className="toggle-sidebar"
                  onClick={() => {
                    setSideBarToggle(!sideBarToggle);
                  }}
                  onBlur={() => {
                    setSideBarToggle(false);
                  }}
                >
                  <i className="icon-menu"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content-wrapper-scroll">
          <div className="content-wrapper">
            {latestNotification ? (
              <div
                className={`alert alert-${latestNotification.color || "light"}`}
                role="alert"
              >
                <strong>{latestNotification.title}</strong>
                {latestNotification.message ? (
                  <> - {latestNotification.message}</>
                ) : (
                  ""
                )}
              </div>
            ) : null}
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
